import React, { useEffect, useState } from "react";
import Header from "../components/Header/Header";
import OuterFooter from "../components/Footer/OuterFooter";

const RefundPolicy = () => {
  const [mobNavbar, setMobNavbar] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <Header mobNavbar={mobNavbar} setMobNavbar={setMobNavbar} />
      <section className="priTos-wrapper mb-5">
        <div className="container px-0">
          <div className="card priTos-card">
            <div className="card-header px-4 py-3 d-flex align-items-center">
              <h2 className="title">Refund and Cancellation Policy</h2>
            </div>
            <div className="card-body px-4 py-3">
              <h3 className="card-title">1. Refunds</h3>
              <p className="card-text">
                All subscription fees are non-refundable for the current billing
                cycle.
              </p>
              <p className="card-text">
                Once a billing period begins, no refunds , full or partial will be issued for any unused portion of that cycle.
              </p>
              <div className="py-2"></div>

              <h3 className="card-title">2. Cancellations</h3>
              <p className="card-text">
                You may cancel your subscription at any time via your account
                dashboard or by contacting our support team.
              </p>
              <p className="card-text">
                Cancellations take effect at the end of your current billing
                cycle. You will retain full access until then, and no further
                charges will be incurred thereafter.
              </p>
              <div className="py-2"></div>

              <h3 className="card-title">3. How to Cancel</h3>
              <p className="card-text">
                <strong>Via Dashboard:</strong> Log in to your Chanakya account,
                go to Billing & Subscriptions, and select Cancel Subscription.
              </p>
              <p className="card-text">
                <strong>Via Email:</strong> Send your cancellation request to
                support@aichanakya.in with the subject line "Subscription
                Cancellation," including your account details.
              </p>
              <div className="py-2"></div>

              <h3 className="card-title">4. Governing Law</h3>
              <p className="card-text">
                This policy is governed by the laws of India. Any disputes related
                to refunds or cancellations will be subject to the exclusive
                jurisdiction of Indian courts.
              </p>
              <div className="py-2"></div>

              <h3 className="card-title">5. Policy Changes</h3>
              <p className="card-text">
                Chanakya may update this policy from time to time. Material
                changes will be posted on our website and, where applicable,
                notified to you by email.
              </p>
              <div className="py-2"></div>

              <p className="card-text">
                For questions or assistance, please contact
                support@aichanakya.in.
              </p>
            </div>
            {/* <div className="card-footer px-4 py-3">
              <CustomLink
                linkText="Contact Us"
                LinkTo={"mailto:support@aichanakya.in"}
              />
            </div> */}
          </div>
        </div>
      </section>
      <OuterFooter />
    </div>
  );
};

export default RefundPolicy;
